import React from "react";
import BlockContent from "@sanity/block-content-to-react";
import { Text, Label, Box } from "../../utils/system";

const BlockRenderer = (props) => {
  const { style = "normal" } = props.node;

  if (/^h\d/.test(style)) {
    const level = style.replace(/[^\d]/g, "");
    return React.createElement(
      style,
      { className: `heading-${level}` },
      props.children
    );
  }

  if (style === "blockquote") {
    return (
      <Box borderLeft="2px solid black" pl={[3, 4]} my={5}>
        <Text fontSize={[3, 4]}>{props.children}</Text>
      </Box>
    );
  }

  if (style === "h2") {
    return <Label fontSize={5}>{props.children}</Label>;
  }

  if (style === "normal") {
    return (
      <Text fontSize={[3, 4]} lineHeight={1.5}>
        {props.children}
      </Text>
    );
  }

  // Fall back to default handling
  return BlockContent.defaultSerializers.types.block(props);
};

const Blocks = ({ blocks }) => {
  return (
    <BlockContent
      className="blocks"
      blocks={blocks}
      serializers={{ types: { block: BlockRenderer } }}
    />
  );
};

export default Blocks;
